export default "__VITE_ASSET__Bumk5Sm7__";